import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { ProductAttributes, ProductKeys } from '~/types/ProductEnums';

/**
 * Determines if the given product is available in the given country.
 *
 * @param      {Object}   product         The product
 * @param      {String}   countryToCheck  The country to check
 * @return     {boolean}  True if product available in country, False otherwise.
 */
export function isProductAvailableInCountry(product, countryToCheck) {
  var _productRef$value, _productRef$value$att, _productRef$value$att2;
  var productRef = ref(product);
  var countryToCheckRef = ref(countryToCheck);
  return !!((_productRef$value = productRef.value) !== null && _productRef$value !== void 0 && (_productRef$value$att = _productRef$value.attributesRaw.find(function (attribute) {
    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === ProductAttributes.availableInCountries;
  })) !== null && _productRef$value$att !== void 0 && (_productRef$value$att2 = _productRef$value$att.value) !== null && _productRef$value$att2 !== void 0 && _productRef$value$att2.find(function (country) {
    return (country === null || country === void 0 ? void 0 : country.key) === countryToCheckRef.value || (country === null || country === void 0 ? void 0 : country.key) === 'ALL';
  }));
}

/**
 * Determines whether the specified variant is in stock.
 *
 * @param      {Object}  variant  The variant (or product) to check.
 * @return     {boolean}  True if the specified variant is in stock, False otherwise.
 */
export function isInStock(variant) {
  var _variantRef$value, _variantRef$value$att, _isSellableAttribute$;
  var variantRef = ref(variant);
  var isSellableAttribute = (_variantRef$value = variantRef.value) === null || _variantRef$value === void 0 ? void 0 : (_variantRef$value$att = _variantRef$value.attributesRaw) === null || _variantRef$value$att === void 0 ? void 0 : _variantRef$value$att.find(function (attribute) {
    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === ProductKeys.isSellable;
  });
  return (isSellableAttribute === null || isSellableAttribute === void 0 ? void 0 : (_isSellableAttribute$ = isSellableAttribute.value) === null || _isSellableAttribute$ === void 0 ? void 0 : _isSellableAttribute$.key) === ProductKeys.inStock;
}

/**
 * Determines whether the specified variant is discontinued.
 *
 * @param      {Object}  variant  The variant (or product) to check.
 * @return     {boolean}  True if the specified variant is discontinued, False otherwise.
 */
export function isDiscontinued(variant) {
  var _variantRef$value2, _variantRef$value2$at, _variantRef$value3, _variantRef$value3$at, _isSellableAttribute$2;
  var variantRef = ref(variant);
  var isProductDiscontinuedAttribute = (_variantRef$value2 = variantRef.value) === null || _variantRef$value2 === void 0 ? void 0 : (_variantRef$value2$at = _variantRef$value2.attributesRaw) === null || _variantRef$value2$at === void 0 ? void 0 : _variantRef$value2$at.find(function (attribute) {
    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === ProductKeys.isProductDiscontinued;
  });
  var isSellableAttribute = (_variantRef$value3 = variantRef.value) === null || _variantRef$value3 === void 0 ? void 0 : (_variantRef$value3$at = _variantRef$value3.attributesRaw) === null || _variantRef$value3$at === void 0 ? void 0 : _variantRef$value3$at.find(function (attribute) {
    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === ProductKeys.isSellable;
  });
  return (isProductDiscontinuedAttribute === null || isProductDiscontinuedAttribute === void 0 ? void 0 : isProductDiscontinuedAttribute.value) || (isSellableAttribute === null || isSellableAttribute === void 0 ? void 0 : (_isSellableAttribute$2 = isSellableAttribute.value) === null || _isSellableAttribute$2 === void 0 ? void 0 : _isSellableAttribute$2.key) === ProductKeys.discontinued;
}

/**
 * Determines whether the specified variant is in low stock.
 *
 * @param      {Object}  variant  The variant (or product) to check.
 * @return     {boolean}  True if the specified variant is in low stock, False otherwise.
 */
export function isLowStock(variant) {
  var _variantRef$value4, _variantRef$value4$at;
  var variantRef = ref(variant);
  var lowStockAttribute = (_variantRef$value4 = variantRef.value) === null || _variantRef$value4 === void 0 ? void 0 : (_variantRef$value4$at = _variantRef$value4.attributesRaw) === null || _variantRef$value4$at === void 0 ? void 0 : _variantRef$value4$at.find(function (attribute) {
    return (attribute === null || attribute === void 0 ? void 0 : attribute.name) === ProductKeys.lowStock;
  });
  return (lowStockAttribute === null || lowStockAttribute === void 0 ? void 0 : lowStockAttribute.value) === true;
}